/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import mbpUtil from 'mbp-api-util';

import restClient from '../../app/helpers/restClient';

const RESOURCE_VERSION_SERVICE = '/v2';
const RESOURCE_PAGE_SERVICE = '/retailers/catalog_select';

const ENV_OBJ = {
    protocol: 'https',
    prefix: '/api',
    host: mbpUtil.getEnv('APP_RESERVE_BAR_CART_HOST'),
};

/**
 * @param {*} params have the delivery information need be search
 * @return Object with the products, price and retailer information according to the address
 */
const getCatalogSelect = ({ payload, jwtToken }) => {
    const envObj = ENV_OBJ || {};
    const params = {
        ...payload,
        client_id: mbpUtil.getEnv('APP_RESERVE_BAR_CLIENT_ID'),
    };

    envObj.rootUri = RESOURCE_VERSION_SERVICE;
    return restClient.postFacade(envObj, RESOURCE_PAGE_SERVICE, jwtToken, params)
        .then((response) => response);
};

export default getCatalogSelect;
